// noinspection DuplicatedCode

import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Button from "@material-tailwind/react/Button";
import Modal from "@material-tailwind/react/Modal";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import Card from "@material-tailwind/react/Card";
import { useMutation } from "@tanstack/react-query";
import { fetchPost, fetchPostSilance } from "../../../../fetchers";
import { toast } from "react-toastify";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Skeltons from "../../../../components/loading/Skeltons";
import { SearchBarSmallV2 } from "../../../../components/form/SearchBar";
import { downloadExcel } from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { getMinKaryawan, karyawanSelector } from "../../karyawan/karyawanSlice";
import { updateIzinTransaksi } from "./izinTransaksiSlice";
import { approve } from "../../../setup/approval/approvalSlice";

import { Colors } from "../../../../assets/Colors";
import { isRequired, useForm } from "../../../../components/isRequired";
import { KaryawanSelectorBuilder } from "../../karyawan/KaryawanSelector";

// Data izin tidak sebanyak transaksi lain — ambil semua sekaligus lalu
// search/pagination/export dilakukan client-side (pola sama dgn Lembur/Kas Bank).
const PAGE_SIZE = 10;

const fmtTgl = (v) => (v ? new Date(v).toLocaleDateString("id-ID") : "-");

const statusClass = (s) =>
  s === "Selesai"
    ? "text-green-600 font-medium"
    : s === "Ditolak" || s === "Revisi"
    ? "text-red-600 font-medium"
    : s === "Belum Dikirim"
    ? "text-gray-500 font-medium"
    : "text-yellow-600 font-medium";

const IzinPage = ({}) => {
  let initialState = {
    Nik: "",
    JenisIzin: -1,
    KeperluanIzin: "",
    Pengganti: "",
    Tiket: false,
  };
  const mutation = useMutation((param) => fetchPost("getIzin", param));

  const mutationInput = useMutation((param) =>
    fetchPostSilance("insertIzin", param)
  );

  const validations = [
    ({ Nik }) => isRequired(Nik) || { Nik: "NIK wajib diisi" },
    ({ JenisIzin }) =>
      isRequired(JenisIzin) || { JenisIzin: "Jenis izin wajib diisi" },
    ({ KeperluanIzin }) =>
      isRequired(KeperluanIzin) || {
        KeperluanIzin: "Keperluan izin wajib diisi",
      },
  ];

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
  } = useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [TanggalMulai, setTanggalMulai] = useState(new Date());
  const [TanggalAkhir, setTanggalAkhir] = useState(new Date());

  const [JamAwal, setTJamAwal] = useState(new Date());
  const [JamAkhir, setJamAkhir] = useState(new Date());

  const [isValidTanggalMulai, setIsValidTanggalMulai] = useState(true);
  const [isValidTanggalAkhir, setIsValidTanggalAkhir] = useState(true);
  const [dateChanged, setDateChanged] = useState(false);

  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const [searchQuery, setSearchQuery] = useState("");
  const [pageC, setPageC] = useState(1);

  const karyawan = useSelector(karyawanSelector);

  useEffect(() => {
    mutation.mutate({ start: 0, count: 100000, search: "" });
  }, []);

  const reapprove = () => {
    mutation.mutate({ start: 0, count: 100000, search: "" });
  };

  function handleCurrentData(values) {
    setCurrentData(values);
  }

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);

    dispatch(getMinKaryawan({ search: "" }));
  }

  if (TanggalMulai !== "" && TanggalAkhir !== "") {
    Math.round(
      (TanggalAkhir.getTime() - TanggalMulai.getTime()) / (1000 * 60 * 60 * 24)
    );
  }
  const selectedNik = karyawan.minData.findIndex((x) => x.Nik === values.Nik);

  // ── Data list (client-side search + pagination) ─────────────
  const allRows = useMemo(() => {
    const d = mutation.data?.data;
    return Array.isArray(d) ? d : [];
  }, [mutation.data]);

  const filtered = useMemo(() => {
    const kw = searchQuery.trim().toLowerCase();
    if (!kw) return allRows;
    return allRows.filter((r) =>
      [r.TIzinID, r.NamaKaryawan, r.JenisIzinKet, r.KeperluanIzin, r.StatusKet]
        .some((v) => v && v.toString().toLowerCase().includes(kw))
    );
  }, [allRows, searchQuery]);

  const totalPage = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const safePage = Math.min(pageC, totalPage);
  const pageRows = useMemo(() => {
    const s = (safePage - 1) * PAGE_SIZE;
    return filtered.slice(s, s + PAGE_SIZE);
  }, [filtered, safePage]);

  useEffect(() => {
    setPageC(1);
  }, [searchQuery, mutation.data]);

  // ── Export (mengikuti hasil filter/search) ───────────────────
  const exportHeader = [
    "ID", "Nama Karyawan", "Jenis Izin", "Keperluan Izin", "Tanggal", "Status Approval",
  ];
  const exportBody = () =>
    filtered.map((r) => [
      r.TIzinID || "",
      r.NamaKaryawan || "",
      r.JenisIzinKet || "",
      r.KeperluanIzin || "",
      r.TanggalMonitoring || "",
      r.StatusKet || "",
    ]);

  const handleDownloadExcel = () => {
    downloadExcel({
      fileName: "Izin",
      sheet: "data",
      tablePayload: { header: exportHeader, body: exportBody() },
    });
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(13);
    doc.text("Izin", 14, 14);
    autoTable(doc, {
      head: [exportHeader],
      body: exportBody(),
      startY: 20,
      styles: { fontSize: 7 },
      headStyles: { fillColor: [30, 58, 95] },
    });
    doc.save("Izin.pdf");
  };

  const colHeader = [
    "ID", "Nama Karyawan", "Jenis Izin", "Keperluan Izin", "Tanggal", "Status Approval", "Actions",
  ];

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                {mutation.isLoading ? (
                  <div className="w-full pt-0">
                    <Skeltons />
                  </div>
                ) : (
                  <>
                    {/* ── Toolbar: Tambah / Export / Search ── */}
                    <div className="flex w-full justify-between px-4 pt-4 flex-col sm:flex-row gap-2">
                      <div className="flex flex-row gap-2 flex-wrap">
                        <button
                          onClick={() =>
                            handleModal({ showModalAdd: true, showModalEdit: false })
                          }
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                        >
                          Tambah +
                        </button>
                        <button
                          onClick={handleDownloadExcel}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-green-600 hover:bg-green-600 hover:text-white rounded shadow"
                        >
                          Download Excel
                        </button>
                        <button
                          onClick={handleDownloadPDF}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-red-400 hover:bg-red-400 hover:text-white rounded shadow"
                        >
                          Download PDF
                        </button>
                      </div>
                      <div className="w-full sm:w-72">
                        <SearchBarSmallV2
                          text={"Cari Izin"}
                          value={searchQuery}
                          funcs={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* ── Tabel ── */}
                    <div className="overflow-x-auto px-4 pt-2">
                      <table className="table-auto w-full text-sm text-left text-gray-500 mt-4">
                        <thead className="text-xs text-orange-600 uppercase bg-gray-50">
                          <tr>
                            {colHeader.map((h, i) => (
                              <th key={i} scope="col" className="py-3 px-6">
                                {h}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {pageRows.length === 0 ? (
                            <tr>
                              <td colSpan={colHeader.length} className="text-center py-8 text-gray-400">
                                {searchQuery ? `Tidak ada data untuk "${searchQuery}"` : "Tidak ada data"}
                              </td>
                            </tr>
                          ) : (
                            pageRows.map((row, id) => (
                              <tr
                                key={row.TIzinID || id}
                                className={id % 2 === 0 ? "bg-gray-50 border-b" : "bg-white border-b"}
                              >
                                <td className="py-4 px-6 whitespace-nowrap font-mono text-xs">{row.TIzinID}</td>
                                <td className="py-4 px-6">{row.NamaKaryawan || "-"}</td>
                                <td className="py-4 px-6">{row.JenisIzinKet || "-"}</td>
                                <td className="py-4 px-6">{row.KeperluanIzin || "-"}</td>
                                <td className="py-4 px-6 whitespace-nowrap text-xs">{row.TanggalMonitoring || "-"}</td>
                                <td className="py-4 px-6">
                                  <span className={statusClass(row.StatusKet)}>{row.StatusKet || "-"}</span>
                                </td>
                                <td className="py-4 px-6 whitespace-nowrap">
                                  {["-1", "-2", "-3"].includes(row.Status) && (
                                    <>
                                      <button
                                        onClick={() => {
                                          handleModal({ showModalAdd: false, showModalEdit: true });
                                          handleCurrentData(row);
                                        }}
                                        className="border text-white bg-main-100 hover:bg-white hover:border-main-100 hover:text-main-100 font-medium rounded-lg text-sm px-4 py-2 mr-2"
                                      >
                                        Edit
                                      </button>
                                      <button
                                        onClick={() => {
                                          try {
                                            reapprove();
                                          } catch (error) {}
                                          dispatch(approve({ primary: row.TIzinID }));
                                        }}
                                        className="border text-white bg-main-100 hover:bg-white hover:border-main-100 hover:text-main-100 font-medium rounded-lg text-sm px-4 py-2"
                                      >
                                        Kirim
                                      </button>
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* ── Info + Pagination ── */}
                    <div className="flex flex-row justify-between items-center gap-4 px-4 py-4 text-sm text-gray-600">
                      <span>{filtered.length} data</span>
                      <div className="flex items-center gap-4">
                        <button
                          onClick={() => setPageC((p) => Math.max(1, p - 1))}
                          disabled={safePage <= 1}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100"
                        >
                          Prev
                        </button>
                        <span>
                          Page {safePage} / {totalPage}
                        </span>
                        <button
                          onClick={() => setPageC((p) => Math.min(totalPage, p + 1))}
                          disabled={safePage >= totalPage}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </Card>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="regular"
        active={showModalAdd}
        toggler={() => {
          setShowModalAdd(true);
        }}
      >
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setTanggalMulai("");
            setTanggalAkhir("");
            setShowModalAdd(false);
            setShowModalEdit(false);
            setButtonTouched(false);
            clearHandler();
          }}
        >
          {showModalEdit ? "Edit Data" : "Tambah Data"}
        </ModalHeader>
        <ModalBody>
          <form className="w-full max-w-lg" onSubmit={submitHandler}>
            <KaryawanSelectorBuilder
              value={values.Nik}
              onChange={customHandler}
            />
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Jenis Izin *
                </label>
                <div className="inline-block relative w-full  ">
                  <select
                    value={values.JenisIzin}
                    onChange={changeHandler}
                    name="JenisIzin"
                    // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    className={
                      (touched.JenisIzin || buttonTouched) && errors.JenisIzin
                        ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                  >
                    <option defaultValue disabled value={-1} hidden>
                      -- Pilih Data --
                    </option>
                    <option value={1}>Pulang Cepat</option>
                    <option value={2}>Terlambat Datang</option>
                    <option value={3}>Keluar Jam Kerja</option>
                    <option value={4}>Tidak masuk kerja</option>

                    {selectedNik >= 0 &&
                      karyawan.minData[selectedNik]["JenisKelamin"] === 0 && (
                        <option value={4}>Sakit Khusus Wanita</option>
                      )}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                  {(touched.JenisIzin || buttonTouched) && errors.JenisIzin && (
                    <p className="text-red-500 text-xs italic">
                      {errors.JenisIzin}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Keperluan Izin *
                </label>
                <input
                  value={values.KeperluanIzin}
                  onChange={changeHandler}
                  name="KeperluanIzin"
                  className={
                    (touched.KeperluanIzin || buttonTouched) &&
                    errors.KeperluanIzin
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.KeperluanIzin || buttonTouched) &&
                  errors.KeperluanIzin && (
                    <p className="text-red-500 text-xs italic">
                      {errors.KeperluanIzin}
                    </p>
                  )}
              </div>
            </div>
            {values.JenisIzin === 4 && (
              <div className="flex flex-wrap -mx-3">
                <div className="w-full md:w-1/2 px-3 mb-6">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Tanggal Mulai *
                  </label>
                  <DatePicker
                    className={
                      !isValidTanggalMulai
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    selected={TanggalMulai}
                    onChange={(date) => {
                      setTanggalMulai(date);
                      setTanggalAkhir("");
                      setIsValidTanggalMulai(true);
                      setIsValidTanggalAkhir(false);
                      if (showModalEdit) {
                        setDateChanged(true);
                      }
                    }}
                  />
                  {!isValidTanggalMulai && (
                    <p className="text-red-500 text-xs italic">
                      Tanggal mulai wajib diisi
                    </p>
                  )}
                </div>
                <div className="w-full md:w-1/2 px-3 mb-6">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Tanggal Akhir *
                  </label>
                  <DatePicker
                    className={
                      !isValidTanggalAkhir
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    disabled={TanggalMulai === ""}
                    minDate={new Date(TanggalMulai).setDate(
                      new Date(TanggalMulai).getDate()
                    )}
                    selected={TanggalAkhir}
                    onChange={(date) => {
                      setTanggalAkhir(date);
                      setIsValidTanggalAkhir(true);
                      if (showModalEdit) {
                        setDateChanged(true);
                      }
                    }}
                  />
                  {!isValidTanggalAkhir && (
                    <p className="text-red-500 text-xs italic">
                      Tanggal akhir wajib diisi
                    </p>
                  )}
                </div>
              </div>
            )}
            <div className="flex flex-wrap -mx-3">
              {(values.JenisIzin === 1 || values.JenisIzin === 3) && (
                <div className="w-full md:w-1/2 px-3 mb-6">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Jam Awal
                  </label>
                  <DatePicker
                    showTimeSelectOnly
                    showTimeInput
                    dateFormat="HH:mm"
                    selected={new Date(JamAwal)}
                    className={
                      "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    onChange={(time) => {
                      setTJamAwal(time);
                    }}
                  />
                  {!isValidTanggalMulai && (
                    <p className="text-red-500 text-xs italic">
                      Tanggal mulai wajib diisi
                    </p>
                  )}
                </div>
              )}
              {values.JenisIzin === 2 || values.JenisIzin === 3 ? (
                <div className="w-full md:w-1/2 px-3 mb-6">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Jam Akhir
                  </label>
                  <DatePicker
                    showTimeSelectOnly
                    showTimeInput
                    dateFormat="HH:mm"
                    selected={new Date(JamAkhir)}
                    className={
                      "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    onChange={(time) => {
                      setJamAkhir(time);
                    }}
                  />
                  {!isValidTanggalMulai && (
                    <p className="text-red-500 text-xs italic">
                      Tanggal mulai wajib diisi
                    </p>
                  )}
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              setTanggalMulai("");
              setTanggalAkhir("");
              setShowModalAdd(false);
              setShowModalEdit(false);
              clearHandler();
            }}
            ripple="dark"
          >
            Cancel
          </Button>

          <Button
            color={
              (isValid || (showModalEdit && dateChanged && !isValid)) &&
              isValidTanggalMulai &&
              isValidTanggalAkhir
                ? "green"
                : "blueGray"
            }
            onClick={() => {
              if (!isValid && changed) {
                setButtonTouched(true);
              }
              let tempIsValid = true;
              if (tempIsValid) {
                const tanggal = {
                  JamAwal: JSON.stringify(JamAwal.toLocaleTimeString()),
                  JamAkhir: JSON.stringify(JamAkhir.toLocaleTimeString()),
                  TanggalMulai: JSON.stringify(TanggalMulai),
                  TanggalAkhir: JSON.stringify(TanggalAkhir),
                  TIzinID: currentData.TIzinID,
                };
                setShowModalAdd(false);
                setShowModalEdit(false);
                if (showModalEdit) {
                  dispatch(updateIzinTransaksi(Object.assign(values, tanggal)));
                  reapprove();
                } else {
                  mutationInput.mutate(Object.assign(values, tanggal), {
                    onSuccess: async (data, context) => {
                      toast.success(data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                      setShowModalAdd(false);
                      setShowModalEdit(false);
                      reapprove();
                    },
                    onError: async (data, context) => {
                      toast.error(data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                    },
                  });
                }
              }
            }}
            ripple={
              isValid && isValidTanggalMulai && isValidTanggalAkhir
                ? "light"
                : ""
            }
          >
            SUBMIT
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default IzinPage;
